import {CSSProperties, useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {TwoFactorVerification} from './components/TwoFactorVerification'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import './auth.scss'

// Onyx treatment over the original site photo: terracotta halo + warm-charcoal
// overlay + the public/ image (set inline — css-loader can't resolve public/
// URLs from SCSS; position/size/repeat live in auth.scss). Same URL as the
// boot splash, so the browser downloads the photo once for both.
export const WC_AUTH_BG: CSSProperties = {
  backgroundImage: [
    'radial-gradient(1100px 560px at 50% -6%, rgba(207, 111, 71, 0.10), transparent 60%)',
    'linear-gradient(165deg, rgba(26, 25, 21, 0.84) 0%, rgba(16, 15, 12, 0.93) 100%)',
    `url(${toAbsoluteUrl('/media/login-background/login-background-8.jpeg')})`,
  ].join(', '),
}

const AuthLayout = () => {
  // Paint the document dark behind the fixed viewport so there's no light flash
  // or light gutter on overscroll; restore on unmount.
  useEffect(() => {
    const prevBg = document.body.style.background
    document.body.style.background = '#141310'
    return () => {
      document.body.style.background = prevBg
    }
  }, [])

  return (
    <div className='wc-auth' style={WC_AUTH_BG}>
      <div className='wc-auth__content'>
        <img
          alt='Web Construct'
          src={toAbsoluteUrl('/media/logos/Web-Construct-Logo-PNG-WHITE.png')}
          className='wc-auth__logo'
        />
        <div className='wc-auth__card'>
          <Outlet />
        </div>
      </div>
      <footer className='wc-auth__footer'>
        © {new Date().getFullYear()} Web Construct
      </footer>
    </div>
  )
}

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      {/* No /auth/registration route — this is a fixed 2-user app; accounts are
          provisioned via the Firebase console, never self-registered. */}
      <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='two-factor' element={<TwoFactorVerification />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
